import { render, staticRenderFns } from "./DetaiCampusAvantage3.vue?vue&type=template&id=ff942fa0"
import script from "./DetaiCampusAvantage3.vue?vue&type=script&lang=js"
export * from "./DetaiCampusAvantage3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports